import Hero from '../../components/Hero/Hero';
import Metadata from '../../components/Metadata/Metadata';

const PageContent: React.FC = () => {
  return (
    <>
      <Metadata
        title="Page Not Found | General Genomics"
        description="Oops! The page you are looking for doesn’t exist. Return to the homepage or explore other sections to learn more about our innovative solutions and services."
      />
      <Hero
        helper="This page seems to have drifted off in the double helix. Let's untangle things and guide you back to safety."
        headline="Lost in the Genome?"
        id="error-hero"
        type="secondary"
        backgroundImg="/images/media/error-404.png"
        btnURL="/"
        btnLabel="Return to homepage"
        btnBgColor="#30C2F5"
      />
    </>
  );
};

export default PageContent;
